import { inject, Injectable, OnDestroy } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { IProjectChange } from '@app/shared/models/project/project-change';
import { IProjectEstimateChange } from '@app/shared/models/project/project-estimate-change';
import * as signalR from "@microsoft/signalr";
import { IEnvironment } from 'environments/ienvironment';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppProjectChangeNotificationService implements OnDestroy {
  //when SignalR is actually implemented
  private hubConnection: signalR.HubConnection;
  public environment = inject(PlexEnvironment);

  public NotifyBulkProjectChange: ReplaySubject<IProjectChange> = new ReplaySubject<IProjectChange>();
  public NotifyProjectChange: ReplaySubject<IProjectChange> = new ReplaySubject<IProjectChange>();
  public NotifyEstimateChange: ReplaySubject<IProjectEstimateChange> = new ReplaySubject<IProjectEstimateChange>();
  private registrations: Map<string, boolean> = new Map();
  private started = false;

  //this can be called by anyone, maybe app startup
  public async appStart(environment: IEnvironment) {
    if (this.started) return;
    this.started = true;

    let url = `${environment.apiUrl}hubs/projectchangeeventHub`;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: () => this.environment.accessToken,
        transport: signalR.HttpTransportType.LongPolling,
        //skipNegotiation: true                                
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    try {
      this.hubConnection.serverTimeoutInMilliseconds = 60000;
      this.hubConnection.keepAliveIntervalInMilliseconds = 15000;
      await this.hubConnection
        .start()
        .then(() => console.log('Connection started'));

      this.startProjectEstimateListener();
      this.startProjectListener();
      this.startBulkProjectListener();
      //this.ready.next(true);
    }
    catch (err) {
      console.error('Error while starting connection: ' + err);

    }
  }

  public async stopConnection() {
    //TODO: Unregister for everything needed.... 
    //await this.UnRegisterSingleProjectNotification(this.ProjectId);
    this.hubConnection.stop();
  }

  private Register(key): boolean {
    if (this.registrations.get(key)) return false;
    this.registrations.set(key, true);
    return true;
  }

  private UnRegister(key): boolean {
    if (!this.registrations.get(key)) return false;
    this.registrations.set(key, false);
    return true;
  }

  public startProjectListener() {
    if (this.Register("AnyProjectChange")) {
      this.hubConnection.on('AnyProjectChange', (data) => {
        this.NotifyProjectChange.next(data);
      });
    };
  }

  public startBulkProjectListener() {
    if (this.Register("BulkProjectChange")) {
      this.hubConnection.on('BulkProjectChange', (data) => {
        this.NotifyBulkProjectChange.next(data);
      });
    };
  }

  public startProjectEstimateListener() {
    if (this.Register('startProjectEstimateListener')) {
      this.hubConnection.on('ProjectEstimateChange', (data) => {
        this.NotifyEstimateChange.next(data);
      });
    }
  }

  async ngOnDestroy() {
    await this.stopConnection();
  }
}